import { createAsyncReducer } from '@telstra-connect/standard-actions';
import {
    IIntMyBillUsageHistoryServiceStatusAction,
    IIntMyBillUsageHistoryServiceStatusSuccessAction,
    IntMyBillUsageHistoryServiceStatusErrorAction
} from '../actions/load-int-mybill-usage-history-service-status';
import { IBillingState } from '../state';
import { initialState } from '../state/initial-state';

export type LoadIntMyBillUsageHistoryServiceStatusAction
    =  IIntMyBillUsageHistoryServiceStatusAction
    | IIntMyBillUsageHistoryServiceStatusSuccessAction
    | IntMyBillUsageHistoryServiceStatusErrorAction

const init = (state: IBillingState, action: LoadIntMyBillUsageHistoryServiceStatusAction) => ({
    ...state,
    intMyBillUsageHistoryServiceStatus: {
        ...state.intMyBillUsageHistoryServiceStatus,
        status: action.status
    }
});

const success = (state: IBillingState, action: LoadIntMyBillUsageHistoryServiceStatusAction) => ({
    ...state,
    intMyBillUsageHistoryServiceStatus: {
        status: action.status,
        data: (action as IIntMyBillUsageHistoryServiceStatusSuccessAction).data
    }
});

const failure = (state: IBillingState, action: LoadIntMyBillUsageHistoryServiceStatusAction) => ({
    ...state,
    intMyBillUsageHistoryServiceStatus: {
        ...initialState.intMyBillUsageHistoryServiceStatus,
        status: action.status,
        error: (action as IntMyBillUsageHistoryServiceStatusErrorAction).error,
        errorCode: (action as IntMyBillUsageHistoryServiceStatusErrorAction).errorCode
    }
});

export const loadIntMyBillUsageHistoryServiceStatusReducer = createAsyncReducer(initialState, init, success, failure);
